<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <div class="userlist-header">
      <div class="userlist-header__title">
        <v-icon dark class="mr-2">mdi-account-group</v-icon>
        <span>유저 리스트</span>
      </div>
      <v-row align="center" no-gutters class="userlist-header__search">
        <v-col cols="12" sm="4" class="pa-1">
          <v-select
              v-model="selected_sort_type"
              :items="user_sort_type"
              label="검색 타입"
              item-text="name"
              item-value="id"
              dense
              solo
              flat
              hide-details
              background-color="rgba(255,255,255,0.15)"
              dark
          ></v-select>
        </v-col>
        <v-col cols="12" sm="5" class="pa-1">
          <v-text-field
              v-model="search_keyword"
              label="유저 아이디 입력"
              hide-details
              dense
              solo
              flat
              background-color="rgba(255,255,255,0.15)"
              dark
              append-icon="mdi-magnify"
              @click:append="OnClick_SearchUser()"
              @keyup.enter="OnClick_SearchUser()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" class="pa-1">
          <v-btn color="white" outlined dark small block @click="OnClick_SearchUser()">
            <v-icon left small>mdi-magnify</v-icon>검색
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <v-data-table         
        :footer-props="{'items-per-page-options':[100, -1]}"
        :headers="selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL' 
            ? headers_type_coin 
            : selected_sort_type === 'REFEREE'
                ? headers_type_referee
                : headers"
        
        :items="search_result"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.USER_ID}}</td>
            <td>{{row.item.NICK}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <td v-if="selected_sort_type !== 'COIN' && selected_sort_type !== 'EARN_COIN_TOTAL'">
                <span class="font-weight-bold" style="color: #1976d2;">
                    {{ formatCoin(row.item) }}  =  ({{ formatCoin_KRW_Convert(row.item) }}원)
                </span>
            </td>
            <td v-if="selected_sort_type !== 'COIN' && selected_sort_type !== 'EARN_COIN_TOTAL'">
                <v-chip 
                    :color="row.item.IS_BANNED === 'Y' ? 'error' : 'success'" 
                    :text-color="row.item.IS_BANNED === 'Y' ? 'white' : 'white'"
                    small
                    dark
                >
                    <v-icon small left>{{ row.item.IS_BANNED === 'Y' ? 'mdi-account-off' : 'mdi-account-check' }}</v-icon>
                    {{ row.item.IS_BANNED === 'Y' ? '탈퇴' : '활성' }}
                </v-chip>
            </td>
            <td>
                {{ GetSortDisplayValue(row.item) }}
                <span v-if="selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL'">
                    ({{ formatCoin_KRW_Convert(row.item) }}원)
                </span>
            </td>
            <td v-if="selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL'">
                <v-chip 
                    :color="row.item.IS_BANNED === 'Y' ? 'error' : 'success'" 
                    :text-color="row.item.IS_BANNED === 'Y' ? 'white' : 'white'"
                    small
                    dark
                >
                    <v-icon small left>{{ row.item.IS_BANNED === 'Y' ? 'mdi-account-off' : 'mdi-account-check' }}</v-icon>
                    {{ row.item.IS_BANNED === 'Y' ? '탈퇴' : '활성' }}
                </v-chip>
            </td>
            <td v-if="selected_sort_type === 'REFEREE'">                
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="Show_UserReferees(row.item)">
                    <v-icon dark>mdi-account-multiple-plus</v-icon>
                </v-btn>
            </td>
            <td>
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="OnClickUser_Mail(row.item)">
                    <v-icon dark>mdi-email-plus</v-icon>
                </v-btn>
                <v-btn class="mx-2" fab dark small color="blue darken-1" @click="OnClickUserInfo(row.item)">
                    <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
            </td>
            <!-- <td v-if='!isLive' >
                <v-btn class="mx-2" fab dark small color="red" @click="clickDeleteUserBtn(row.item.USER_ID)">
                    <v-icon dark>mdi-delete</v-icon>
                </v-btn>
            </td> -->
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-card>    

     <v-dialog
        v-model="dialog_referee_list"
        persistent
        max-width="1200"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        @keydown.esc="Close_Referee_Dialog"
        tabindex="0"
    >
    <v-card>
        <v-card-title class="text-h5">
        추천인 리스트 ( {{ dialog_referee_list_items.length }} 명)
        </v-card-title>

        <div style="max-height: 800px; overflow-y: auto;">
        <v-data-table         
            :headers="headers_referees" 
            :items="dialog_referee_list_items"
            :items-per-page="20"      
            class="elevation-1"
        >        
            <template v-slot:item="row">            
            <tr>
                <td>{{ row.item.USER_ID }}</td>
                <td><b>{{ row.item.NICK }}</b></td>
                <td>{{ row.item.PHONE }}</td>
                <td>{{ row.item.CUR_BP }}</td>
                <td>{{ row.item.CREATE_DT }}</td>
            </tr>
            </template>
        </v-data-table>
        </div>

        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="Close_Referee_Dialog"
        >
            확인
        </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    </div> 
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
import store from '../../store';
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,
        search_keyword:'',
        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [            
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '보유 코인', value: 'coin' },
            { text: '탈퇴여부', value: 'is_banned' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },            
            // { text: '', value: 'delete' },
        ],
        headers_type_coin: [            
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '탈퇴여부', value: 'is_banned' },
            // { text: '현금화', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },            
            // { text: '', value: 'delete' },
        ],
         headers_type_referee: [            
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '추천인보기', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },            
            // { text: '', value: 'delete' },
        ],
        user_sort_type: [
            {id:"RECENT", name:"최신 가입순"},
            {id:"REFEREE", name:"추천인순"},            
            // {id:"CUR_BP", name:"채굴기 강화순_현재"},
            // {id:"DAILY_BP", name:"채굴기 강화순 (오늘)"},
            {id:"COIN", name:"현재 보유코인"},
            {id:"EARN_COIN_TOTAL", name:"누적 획득 코인"},
        ],        
        headers_referees: [
            { text :'유저 아이디', value: 'USER_ID' },
            { text: '닉네임', value: 'NICK'},
            { text: '전화번호', value: 'PHONE'},
            { text: '적용중 채굴기', value: 'CUR_BP'},
            { text: '생성일', value: 'CREAT_DT'},
        ],
        selected_sort_type:"",
        search_result:[],
        total_count:0,
        dialog_referee_list_items:[],
        dialog_referee_list:false
    }),

    created()
    {
        let count = 30;
        this.selected_sort_type = "RECENT";
        // this.GET_RECENT_USER_LIST({count}).then((body_data)=>{
        //     let user_list = body_data.user_list;
        //     this.search_result = user_list;
        // });
    },

    methods:{
        ...mapActions([
            'QUIZANDCASH_GET_USERLIST_RECENT',
            'QUIZANDCASH_GET_USERLIST_REFEREE',
            'QUIZANDCASH_GET_USERLIST_ENJOY_AD',
            'QUIZANDCASH_GET_USERLIST_HAVE_COIN',
            'QUIZANDCASH_GET_SEARCH_USER_LIST',
            'QUIZANDCASH_DELETE_USER',
            'QUIZANDCASH_GET_USER_REFEREE_LIST',
        ]),
        async clickDeleteUserBtn(user_id) {
            console.log('유저 하나 삭제 클릭됨')
            let packageName = this.$store.state.selected_game_package;
            if (confirm(`${user_id} 유저를 삭제하시겠습니까?`)) {                    
                await this.QUIZANDCASH_DELETE_USER({packageName, user_id})
                alert("삭제 완료");
                let count = 30;
                let server_index = this.$store.state.selected_game_server;
                const requestResult = await this.QUIZANDCASH_GET_RECENT_USER_LIST({packageName  ,  server_index, count})
                console.log(requestResult)
                const userList = requestResult.user_list
                this.search_result = userList
            }
        },
        GetSortInfo(item){
            if(this.selected_sort_type == 'RECENT')
                return '';
            if(this.selected_sort_type == 'REFEREE')
                return item.REF_COUNT || 0;
            if(this.selected_sort_type == 'CUR_BP')
                return item.CUR_BP || 0;
            if(this.selected_sort_type == 'DAILY_BP')
                return item.DAILY_BP || 0;
            if(this.selected_sort_type == 'COIN')
                return item.COIN || 0;
            if(this.selected_sort_type == 'EARN_COIN_TOTAL')
                return item.TOTAL_EARN_COIN || 0;
            return '';
        },
        GetSortDisplayValue(item) {
            const info = this.GetSortInfo(item);
            if (typeof info === 'number') {
                return info.toLocaleString();
            }
            return info;
        },
        formatCoin(item) {
            let value = 0;
            if (typeof item === 'object' && item !== null) {
                value = item.COIN || 0;
            } else {
                value = item || 0;
            }
            return Math.floor(Number(value)).toLocaleString();
        },
        OnClickUserInfo(_item)
        {
            //this.loadingData = true;
            //alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
            this.loadingData = false;
            this.$router.push('/quizcash_user_info?USER_ID='+_item.USER_ID);
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            this.$router.push('/quizcash_mail?USER_ID='+_item.USER_ID);
        },
        OnClick_SearchUser()
        {
            if(this.search_keyword.length < 1)
            {
                alert('검색어는 1자이상 입력해주세요');
                return;
            }

            let keyword = this.search_keyword;
            this.QUIZANDCASH_GET_SEARCH_USER_LIST({keyword}).then((body_data)=>{
            let user_list = body_data.user_list;
            this.search_result = user_list;
        });
        },
        formatCoin_KRW_Convert(item) {
            let value = 0;
            if (typeof item === 'object' && item !== null) {
                if (this.selected_sort_type === 'EARN_COIN_TOTAL') {
                    value = item.TOTAL_EARN_COIN || 0;
                } else {
                    value = item.COIN || 0;
                }
            } else {
                value = item || 0;
            }
            
            let numValue = Number(value);
            if (isNaN(numValue)) return "0";
            let convert = numValue / 2.37;
            return Math.floor(convert).toLocaleString();    
        },
        async Load_And_Setting(){
            console.log("Load_And_Setting");
            if(this.selected_sort_type == "RECENT"){ //최신순 
                console.log(this.selected_sort_type);
                if(this.$store.state.user_list_quizcash_sort_recent.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_RECENT({count:100}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("RECENT : : 다시 불러옴 ");
                        store.commit("SET_QUIZCASH_USERLIST_RECENT", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_recent;
                }
            } else if(this.selected_sort_type == "REFEREE") {
                if(this.$store.state.user_list_quizcash_sort_referee.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_REFEREE({count:100}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("REFEREE : : 다시 불러옴 ");
                        store.commit("SET_QUIZCASH_USERLIST_REFEREE", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_referee;
                }
                 
            } else if(this.selected_sort_type == "CUR_BP") {
                if(this.$store.state.user_list_quizcash_sort_cur_bp.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_ENJOY_AD({count:100 , type:'CUR'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("CUR_BP : 다시 불러옴 ");
                        store.commit("SET_QUIZCASH_USERLIST_BP_CUR", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_cur_bp;
                }
               
            } else if(this.selected_sort_type == "DAILY_BP") {
                if(this.$store.state.user_list_quizcash_sort_daily_bp.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_ENJOY_AD({count:100 , type:'DAILY'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("DAILY_BP : 다시 불러옴 ");
                        store.commit("SET_USERLIST_BP_DAILY", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_daily_bp;
                }
                
            } else if(this.selected_sort_type == "COIN") {
                  if(this.$store.state.user_list_quizcash_sort_point.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_HAVE_COIN({count:100 , type:'CUR'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("COIN : 다시 불러옴 ");
                        store.commit("SET_QUIZCASH_USERLIST_COIN", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_point;
                }
             
            } else if(this.selected_sort_type == "EARN_COIN_TOTAL") {
                  if(this.$store.state.user_list_quizcash_sort_point_total.length == 0){//안불러왔으니 서버로부터 불러온다                     
                    await this.QUIZANDCASH_GET_USERLIST_HAVE_COIN({count:100 , type:'TOTAL'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("EARN_COIN_TOTAL : 다시 불러옴 ");
                        store.commit("SET_QUIZCASH_USERLIST_EARN_COIN_TOTAL", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_quizcash_sort_point_total;
                }
            }
            

        },
        Show_UserReferees(item){
                this.QUIZANDCASH_GET_USER_REFEREE_LIST({user_id: item.USER_ID}).then((body_data)=>{
                this.dialog_referee_list_items = body_data.result;
                // console.log('추천인들의 정보를 가져옵니다. ' + JSON.stringify(body_data));
                // console.log('추천인들의 정보를 가져옵니다. ' + JSON.stringify(this.dialog_referee_list_items));
                this.dialog_referee_list = true;                    
            });
        },
        Close_Referee_Dialog(){
            this.dialog_referee_list = false;                    
        }

    },
    computed: {
        isLive(){
            return config.isLive;
        },        
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            let count = 30;
            this.QUIZANDCASH_GET_RECENT_USER_LIST({packageName , server_index, count}).then((body_data)=>{
            let user_list = body_data.user_list;
            console.log("JS:"+JSON.stringify(user_list));
            this.search_result = user_list;
        });
        },
        '$store.state.selected_game_server': function() {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            let count = 30;
            this.QUIZANDCASH_GET_RECENT_USER_LIST({packageName , server_index, count}).then((body_data)=>{
            let user_list = body_data.user_list;
            console.log("JS:"+JSON.stringify(user_list));
            this.search_result = user_list;
        });
        },
        selected_sort_type(newVal) {
            let sortType = newVal;       
            console.log(this.selected_sort_type);
            this.Load_And_Setting();
        },
        '$store.state.user_list_quizcash_sort_recent': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_recent;
        },
        '$store.state.user_list_quizcash_sort_referee': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_referee;
        },
        '$store.state.user_list_quizcash_sort_cur_bp': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_cur_bp;
        },
        '$store.state.user_list_quizcash_sort_daily_bp': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_daily_bp;
        },
        '$store.state.user_list_quizcash_sort_point': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_point;
        },
        '$store.state.user_list_quizcash_sort_point_total': function() {
            this.search_result = this.$store.state.user_list_quizcash_sort_point_total;
        }


    }
};
</script>
<style scoped>
.userlist-header {
  background: var(--cms-toolbar-gradient, linear-gradient(135deg, #0277BD 0%, #0288D1 50%, #039BE5 100%));
  padding: 16px;
}
.userlist-header__title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
.userlist-header__search {
  margin: 0;
}
@media (max-width: 600px) {
  .userlist-header {
    padding: 12px;
  }
  .userlist-header__title {
    font-size: 17px;
    margin-bottom: 8px;
  }
  .v-data-table {
    overflow-x: auto;
  }
}
</style>
